// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class CustomEvent {
    constructor() {
        this.Subscribers = [];
    }
    Subscribe(method, context) {
        this.Subscribers.push({
            method,
            context
        });
    }
    UnSubscribe(method, context) {
        let idxToRemove;
        const subs = this.Subscribers;
        const len = subs.length;
        for (let i = 0; i < len; i++) {
            const sub = subs[i];
            if (sub.method === method && sub.context === context) {
                idxToRemove = i;
                break;
            }
        }
        if (idxToRemove === undefined) {
            return;
        }
        subs.splice(idxToRemove, 1);
    }
    Raise(q = undefined, w = undefined, e = undefined, r = undefined, t = undefined) {
        const subs = [...this.Subscribers];
        const len = subs.length;
        for (let i = 0; i < len; i++) {
            const sub = subs[i];
            sub.method.call(sub.context, q, w, e, r, t);
        }
    }
    clearSubscribers() {
        this.Subscribers = [];
    }
}
